import { publishers } from '@/configs/translates.config';

export default {
	'add-new-publisher': `Add new ${publishers.en.singular}`,
	publisher: publishers.en.singular,
	'the-publisher': `the ${publishers.en.singular}?`
}